import { useLazyQuestionnaireResultItemsQuery } from '../../../../../graphql/graphql';
import { QUESTIONNAIRE_ENTRY_CODE } from '../../../constants';

export default function useMothersWeightBeforePregnancy() {
	const [getQuestionnaireResultItems] = useLazyQuestionnaireResultItemsQuery();

	const getMothersWeightBeforePregnancy = async (patientId: string) => {
		const data = await getQuestionnaireResultItems({
			questionnaireCode: QUESTIONNAIRE_ENTRY_CODE,
			patientId: patientId,
		});

		if (data) {
			const questions = data?.data?.questionnaireResultItems?.data;
			if (questions) {
				const question = questions.find(
					({ question }: any) =>
						question.key === 'mothersHealth.weighBeforePregnancy',
				);
				return parseInt(question?.valueJson.rawValue);
			}
		}

		return 0;
	};

	return {
		getMothersWeightBeforePregnancy,
	};
}
